// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_m1-0";
export var discountCodeInput = "_m1-1";